import { Component, inject } from '@angular/core';
import { UserAuthService } from '../../../services/user/user-auth.service';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { ZendeskChatService } from '../../../services/zendesk/zendesk-chat.service';

@Component({
  selector: 'app-full-account-lock',
  imports: [
    TranslatePipe,
  ],
  templateUrl: './full-account-lock.component.html',
  styleUrl: './full-account-lock.component.scss',
})
export class FullAccountLockComponent {

  private _authUser = inject(UserAuthService);
  public zendesk = inject(ZendeskChatService);

  public onLogout() {
    this._authUser.logoutUser(() => {
    });
  }
}
